import { AbstractControl, ValidationErrors, FormControl } from '@angular/forms';

export function emailValidator(control: AbstractControl): { [Key: string]: boolean } | null {
    const email = control.get('email');
    const confirmEmail = control.get('confirmEmail');
    const emailOptIn = control.get('emailOptIn');
    if (email.pristine || confirmEmail.pristine) {
        return null;
    }
    // if (email && confirmEmail && email.value !== confirmEmail.value && emailOptIn.value === true) {
    if (email && confirmEmail && email.value !== confirmEmail.value) {
        return { 'misMatch': true };
    }
}

export function phoneValidator(control: AbstractControl): { [Key: string]: boolean } | null {

    const phone = control.get('phone');
    const confirmPhone = control.get('confirmPhone');
    const phoneOptIn = control.get('phoneOptIn');

    if (phone.pristine || confirmPhone.pristine) {
        return null;
    }
    // if (phone && confirmPhone && phone.value !== confirmPhone.value && phoneOptIn.value === true) {
    if (phone && confirmPhone && phone.value !== confirmPhone.value) {
        return { 'misMatchPass2': true };
    }
}

export class NoMoreSpace {
    static cannotContainSpace(control: AbstractControl): ValidationErrors | null {

        const textVal = control.value.replace(/^\s+|\s+$/g, '');
        const CharArray = control.value.split(' ');
        if (CharArray.length > 2) {
            return {cannotContainSpace: true};
        }

        return null;
    }
}

export class UsernameValidator {
    // static cannotContainSpace1(control: AbstractControl): ValidationErrors | null {
    //     if ((control.value as string).indexOf(' ') >= 0) {
    //         return {cannotContainSpace: true};
    //     }
    //     return null;
    // }
    static noWhitespaceValidator(control: FormControl) {
        const isWhitespace = (control.value || '').trim().length === 0;
        const isValid = !isWhitespace;
        return isValid ? null : { 'whitespace': true };
    }
}



